<template>
  <v-container class="pt-5 pb-0">
    <v-layout row wrap>
      <v-flex xs12>
        <v-text-field
          v-model="title"
          outline
          single-line
          @blur="$emit('delivery', title)"
          @keydown.enter="$emit('delivery', title)"
          placeholder="タイトルを入力してください"
          color="#FF7885"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: {
    init_title: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      title: this.init_title
    };
  },
  computed: {
    getTitle() {
      return this.init_title;
    }
  },
  watch: {
    getTitle() {
      this.setTitle();
    }
  },
  methods: {
    setTitle() {
      this.title = this.init_title;
    }
  }
}
</script>